import PriceListsAndPromotionsToEventTransformer from '../transformers/PriceListsAndPromotionsToEventTransformer'
import PriceListsAndPromotionsToEventsTransformer from '../transformers/PriceListsAndPromotionsToEventsTransformer'
import EventToProductIdsTransformer from '../transformers/EventToProductIdsTransformer'
import EventAndProductCombiningTransformer from '../transformers/EventAndProductCombiningTransformer'

import ProductRepository from './ProductRepository'

class EventRepository {
  /**
   * @name EventRepository#api
   * @type {Api}
   */

  /**
   * @name EventRepository#maxCustomerGroupId
   * @type {int}
   */

  /**
   * @param {Api} api
   */
  constructor (api) {
    this.api = api
  }

  setMaxCustomerGroupId (maxCustomerGroupId) {
    this.maxCustomerGroupId = maxCustomerGroupId
  }

  getStatuses () {
    return [
      {
        text: 'Locked',
        value: 'LOCKED'
      },
      {
        text: 'Confirmed',
        value: 'CONFIRMED'
      },
      {
        text: 'In Preparation',
        value: 'IN_PREPARATION'
      }
    ]
  }

  getStatusesForFilter () {
    return [
      {
        text: 'Confirmed/Locked',
        value: 'CONFIRMED_AND_LOCKED'
      },
      {
        text: 'Confirmed',
        value: 'CONFIRMED'
      },
      {
        text: 'In Preparation',
        value: 'IN_PREPARATION'
      }
    ]
  }

  getTypes () {
    return [
      {
        text: 'Flyer',
        value: 'FLYER_MASTER'
      },
      {
        text: 'Manager\'s special',
        value: 'MANAGERS_SPECIAL_MASTER'
      },
      {
        text: 'Other',
        value: 'OTHER_MASTER'
      }
    ]
  }

  getReasonNameTypes () {
    return {
      'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS': 'Buy and Get Percent Off',
      'BUY_ITEMS_GET_SUM_OFF_ITEMS': 'Buy and Get Dollar Off',
      'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE': 'Multi-Buy',
      'SPEND_GET_PERCENTAGE_OFF_ITEMS': 'Spend and Get Percent Off',
      'SPEND_GET_SUM_OFF_ITEMS': 'Spend and Get Dollar Off',
      'MULTIBUY_GET_PERCENTAGE_OFF': 'Item % off',
      'MULTIBUY_GET_SUM_OFF': 'Item $ off'
    }
  }

  getCustomerGroups (groupIds) {

    return [{text: 'Email Member', value: groupIds.emailMemberGroupId}, {text: 'Non-Email Member', value: groupIds.nonEmailMemberGroupId }, {text: 'Non-Member', value: groupIds.nonMemberGroupId}]
  }

  getStoreRegions () {
    return this.api.storeRegions.get()
  }

  getEventsByPage (pageNo, params) {
    let transformer = new PriceListsAndPromotionsToEventsTransformer()

    if (typeof pageNo === 'undefined') pageNo = 1

    return this.api.events.getEventsByPage(pageNo, params)
      /*      .then(masterPriceLists => { //TOOD: this logic should be on api side.
              return masterPriceLists.sort((a, b) => {
                if (!a.startDate) {
                  return -1
                } else if (!b.startDate) {
                  return 1
                } else if (a.startDate < b.startDate) {
                  return 1
                } else if (a.startDate > b.startDate) {
                  return -1
                } else {
                  return 0
                }
              })
            })*/
      .then(resp => {

        console.log('pre transform: ', resp)
        resp.records = transformer.transform(resp.records, [], [])
        return resp
      })
  }

  getAllEvents () {
    let transformer = new PriceListsAndPromotionsToEventsTransformer()

    return this.api.events.getEvents()
      .then(masterPriceLists => {
        return masterPriceLists.sort((a, b) => {
          if (!a.startDate) {
            return -1
          } else if (!b.startDate) {
            return 1
          } else if (a.startDate < b.startDate) {
            return 1
          } else if (a.startDate > b.startDate) {
            return -1
          } else {
            return 0
          }
        })
      })
      .then(masterPriceLists => {
        return transformer.transform(masterPriceLists, [], [])
      })
  }

  getEvent (id) {
    //alert('getEvent')
    let eventTransformer = new PriceListsAndPromotionsToEventTransformer()
    let productRepository = new ProductRepository(this.api)
    let productIdTransformer = new EventToProductIdsTransformer()
    let combiningTransformer = new EventAndProductCombiningTransformer()
    productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId)

    return this.api.events.getEvent(id)
      .then(event => {
        return this.api.products.getProducts(id)
          .then(products => {
            return this.api.campaigns.getCampaigns(id)
              .then(campaigns => {
                event = eventTransformer.transform(event, products, campaigns)
                let productIds = productIdTransformer.transform(event)

                return productRepository.getProductsWithBasePricesAndCost(productIds, event.regionId, event.startDate, event.endDate)
                  .then(productsWithBasePricesAndCost => combiningTransformer.transform(event, productsWithBasePricesAndCost))
              })
          })
      })
  }

  createEvent (eventOrig) {
    let event = JSON.parse(JSON.stringify(eventOrig))
    event.name = {
      'en': event.name,
      'fr': event.name
    }
    return this.api.events.createNewEvent(event).then(event => {
      return event
    })
  }

  async copyEvent (event) {
    let productRepository = new ProductRepository(this.api)
    let discountedProducts = event.discountedProducts
    let specialPromotions = event.specialPromotions
    discountedProducts.forEach(product => (delete product.priceListProductId))
    specialPromotions.forEach(campaign => {
      delete campaign.campaignId
      delete campaign.eventId
      delete campaign.id
    })

    productRepository.setMaxCustomerGroupId(this.maxCustomerGroupId)

    return await this.createEvent(event)
      .then(eventId => {
        return this.getEvent(eventId.id)
          .then(newEvent => {
            newEvent.discountedProducts = discountedProducts
            newEvent.specialPromotions = specialPromotions
            let productIds = newEvent.discountedProducts.map(product => product.id)
            return productRepository.getProductsWithBasePricesAndCost(productIds, newEvent.regionId)
              .then(products => {
                let discountedProducts = this.recalculateDiscountedPrices(newEvent.discountedProducts, products)
                return Object.assign(newEvent, {discountedProducts})
              })
          })
      })
      .then(async eventWithDiscountsAndPromotions => {
        eventWithDiscountsAndPromotions.isConfirmed = false
        eventWithDiscountsAndPromotions.isLocked = false
        return await this.saveEvent(eventWithDiscountsAndPromotions).then(() => eventWithDiscountsAndPromotions)
      })
  }

  recalculateDiscountedPrices (eventDiscountsInPreviousRegion, productsInNewRegion) {
    return eventDiscountsInPreviousRegion.map(eventDiscount => {
      let discountedProductChanges = productsInNewRegion.reduce((result, foundProduct) => {
        if (foundProduct.productID !== eventDiscount.id) {
          return result
        }

        let basePriceDifference
        if (eventDiscount.customerGroupId !== 0) {
          console.log('eventDiscount.customerGroupId !== 0 -> yes')
          console.log(eventDiscount.regularCustomerGroupPrice, foundProduct.regionCustomerGroupBasePrice, eventDiscount.salesPrice )

          basePriceDifference = eventDiscount.regularCustomerGroupPrice - foundProduct.regionCustomerGroupBasePrice
        } else {
          console.log('eventDiscount.customerGroupId !== 0 -> no')
          console.log(eventDiscount.regularPrice, foundProduct.regionBasePrice, eventDiscount.salesPrice)

          basePriceDifference = eventDiscount.regularPrice - foundProduct.regionBasePrice
        }

        return {
          salesPrice: eventDiscount.salesPrice - basePriceDifference,
          cost: foundProduct.regionCost
        }
      }, {})

      return Object.assign({}, eventDiscount, discountedProductChanges)
    })
  }

  async saveEvent (eventOrig) {
    console.log('saveEvent')
    console.log(eventOrig)
    let addedProducts = []
    let editedProducts = []
    let addedCampaigns = []
    let editedCampaigns = []
    let deletedProducts = []
    let deletedCampaigns = []
    let event = JSON.parse(JSON.stringify(eventOrig))

    let promises = []

    event.discountedProducts.map(product => {
      product.targetMargin = parseFloat(product.targetMargin)
      product.price = product.salesPrice
      product.customerGroupId = (product.customerGroupId === 0) ? null : product.customerGroupId; // ESLint will go crazy if semicolon is removed
      (product.priceListProductId) ? editedProducts.push(product) : addedProducts.push(product)
    })

    event.specialPromotions.map(promotion => {
      if (promotion.type === 'MULTIBUY_X_FOR_DISCOUNT' || promotion.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || promotion.type === 'MULTIBUY_GET_SUM_OFF') {
        console.log('before 1')
        console.log(promotion)

        promotion.rewards.sumOffMatchingItems = promotion.rewards.sumOff ? promotion.rewards.sumOff.valueOf() : promotion.rewards.sumOffMatchingItems

        promotion.rewards.percentageOffMatchingItems = promotion.rewards.percentageOff ? promotion.rewards.percentageOff.valueOf() : promotion.rewards.percentageOffMatchingItems

        console.log('after 1')
        console.log(promotion)
        console.log('delete 1')

        //TODO: fix me. wont compile with .?
        if (promotion.rewards.awardedProducts) {

          promotion.rewards.awardedProducts = promotion.rewards.awardedProducts.map(product => {
            return {productId: product.productID ? product.productID : product.productId}
          })
        }

        delete promotion.rewards.sumOff
        delete promotion.rewards.percentageOff
      }

      promotion.customerGroupId = (promotion.customerGroupId === 0) ? null : promotion.customerGroupId; // ESLint will go crazy if semicolon is removed
      (promotion.campaignId) ? editedCampaigns.push(promotion) : addedCampaigns.push(promotion)
    })

    event.deletedDiscountsAndPromotions.map(item => {
      if (item.campaignId) {
        deletedCampaigns.push(item)
      } else if (item.priceListProductId) {
        deletedProducts.push(item)
      }
    })

    let errors = {}

    addedProducts.map(product => {
      product.productId = product.id

      promises.push(
        this.api.products.addProduct(event.id, product)
          .then(response => {
            product.priceListProductId = response.data.priceListProductId
          })
          .catch(error => {
            errors[product.productId] = (error.data && error.data.validationErrors) ? error.data.validationErrors : null
          })
      )
    })

    editedProducts.map(product => {
      if (product.hasBeenEdited) promises.push(this.api.products.edit(event.id, product))
    })

    deletedProducts.map(product => {
      promises.push(this.api.products.remove(event.id, product))
    })

    deletedCampaigns.map(campaign => {
      promises.push(this.api.campaigns.remove(event.id, campaign))
    })

    console.log('promises1')
    console.log(promises)
    const {campaignPromises, campaignErrors} = await this.saveCampaigns(addedCampaigns, editedCampaigns, event)
   //   .then(({campaignPromises, campaignErrors}) => {
      console.log('promises3')
      console.log(campaignPromises)
      promises = promises.concat(campaignPromises)
      errors = Object.assign(errors, campaignErrors)


    event.name = {
      'en': event.name,
      'fr': event.name
    }



    console.log('promises2')
    console.log(promises)
 //   return
    await Promise.all(promises)
    event = await this.api.events.save(event)
    return { event, errors }
  }

  async saveCampaigns (addedCampaigns, editedCampaigns, event) {
    console.log('saveCampaigns')
    const reasons = await this.api.events.getReasonCodes()
      let campaignPromises = []
      let campaignErrors = {}
      addedCampaigns.map(campaign => {
        let addedCampaign = JSON.parse(JSON.stringify(campaign))

        if (addedCampaign.name && typeof addedCampaign.name !== 'object') {
          addedCampaign.name = {
            'en': addedCampaign.name,
            'fr': addedCampaign.nameLat
          }
        }

        let eventType = ''
        this.getTypes().map(type => {
          if (type.value === event.type) eventType = type.text
        })

        reasons.map(reason => {
          if (reason.name === (eventType + '-' + this.getReasonNameTypes()[addedCampaign.type])) addedCampaign.reasonId = reason.reasonID

        })
        addedCampaign.requirements.purchasedProducts = addedCampaign.requirements.purchasedProducts.map(product => {
          return {productId: product.productID ? product.productID : product.productId}
        })

        addedCampaign.rewards.awardedProducts = addedCampaign.rewards.awardedProducts.map(product => {
          return {productId: product.productID ? product.productID : product.productId}
        })

        switch (addedCampaign.type) {
          case 'SPEND_GET_SUM_OFF_ITEMS':
            addedCampaign.rewards.lowestPriceItemIsAwarded = false
            break
          case 'SPEND_GET_PERCENTAGE_OFF_ITEMS':
            addedCampaign.rewards.lowestPriceItemIsAwarded = true
            break
          case 'BUY_ITEMS_GET_SUM_OFF_ITEMS':
            addedCampaign.rewards.lowestPriceItemIsAwarded = false
            break
          case 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS':
            addedCampaign.rewards.lowestPriceItemIsAwarded = false
            break
          case 'MULTIBUY_GET_PERCENTAGE_OFF':
            addedCampaign.rewards.lowestPriceItemIsAwarded = false
            break
          case 'MULTIBUY_GET_SUM_OFF':
            addedCampaign.rewards.lowestPriceItemIsAwarded = false
            break

          default:
            break
        }

        if (typeof addedCampaign.oncePerDay == 'undefined' || addedCampaign.oncePerDay === '')
        {
          addedCampaign.oncePerDay = 0;
        }

        if (typeof addedCampaign.rewards.redemptionLimit !== 'undefined')
        {
          if (addedCampaign.rewards.redemptionLimit === '')
            addedCampaign.rewards.redemptionLimit = null;
        }

        if (typeof addedCampaign.rewards.salesRedemptionLimit !== 'undefined')
        {
          if (addedCampaign.rewards.salesRedemptionLimit === '')
            addedCampaign.rewards.salesRedemptionLimit = null;
        }

        if (typeof addedCampaign.oncePerDay == 'undefined' || addedCampaign.oncePerDay === '')
        {
          addedCampaign.oncePerDay = 0;
        } else {
          addedCampaign.oncePerDay = parseInt(addedCampaign.oncePerDay)
        }

        if (addedCampaign.type === 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || addedCampaign.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || addedCampaign.type === 'MULTIBUY_GET_SUM_OFF') {
          console.log('before 2')
          console.log(addedCampaign)
          addedCampaign.rewards.sumOffMatchingItems = addedCampaign.rewards.sumOff ? addedCampaign.rewards.sumOff.valueOf() : addedCampaign.rewards.sumOffMatchingItems
          addedCampaign.rewards.percentageOffMatchingItems = addedCampaign.rewards.percentageOff ? addedCampaign.rewards.percentageOff.valueOf() : addedCampaign.rewards.percentageOffMatchingItems
          console.log('after 2')
          console.log(addedCampaign)
          console.log('delete 2')
          delete addedCampaign.rewards.sumOff
          delete addedCampaign.rewards.percentageOff
        }

        //same for edit.
        if (addedCampaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || addedCampaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {
          if (!addedCampaign.rewards.percentageOff) {
            delete addedCampaign.rewards.percentageOff
          }

          if (!addedCampaign.rewards.percentageOffMatchingItems ) {
            delete addedCampaign.rewards.percentageOffMatchingItems
          }

          if (!addedCampaign.rewards.sumOffMatchingItems) {
            delete addedCampaign.rewards.sumOffMatchingItems
          }
        }

        if (addedCampaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || addedCampaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || addedCampaign.type == 'MULTIBUY_GET_SUM_OFF' || addedCampaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {

          delete addedCampaign.rewards.specialUnitPrice
        }

        if (addedCampaign.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || addedCampaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

          if (!addedCampaign.rewards.percentageOffMatchingItems ) {
            delete addedCampaign.rewards.percentageOffMatchingItems
          }

          if (!addedCampaign.rewards.sumOffMatchingItems) {
            delete addedCampaign.rewards.sumOffMatchingItems
          }

          delete addedCampaign.subsidyPercentageOfDiscount
          delete addedCampaign.rewards.rewardMoneyEarnedPerRedemption
        }



        if (addedCampaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

          if (!addedCampaign.rewards.sumOff ) {
            delete addedCampaign.rewards.sumOff
          }

        }

        if (addedCampaign.type == 'MULTIBUY_GET_SUM_OFF') {
          if (!addedCampaign.rewards.percentageOffMatchingItems ) {
            delete addedCampaign.rewards.percentageOffMatchingItems
          }
          delete addedCampaign.subsidyPercentageOfDiscount
          delete addedCampaign.rewards.rewardMoneyEarnedPerItem
        }

        if (addedCampaign.type == 'MULTIBUY_GET_PERCENTAGE_OFF') {
          delete addedCampaign.subsidyPercentageOfDiscount
          delete addedCampaign.rewards.rewardMoneyEarnedPerItem
        }

        if (addedCampaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || addedCampaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {

          addedCampaign.rewards.salesRedemptionLimit = addedCampaign.rewards.redemptionLimit

          delete addedCampaign.rewards.redemptionLimit
        }

        if (addedCampaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {
          delete  addedCampaign.rewards.rewardMoneyEarnedPerItem
          delete addedCampaign.targetMargin
        }
        //////////////////////////////////////////////////////////////////

        campaignPromises.push(
          this.api.campaigns.addCampaign(addedCampaign, event.id)
            .then(response => {
              campaign.campaignId = response.data.campaignId
            })
            .catch(error => {
              if (error.data && error.data.validationErrors) campaignErrors[campaign.id] = error.data.validationErrors
            })
        )
      })
      editedCampaigns.map(campaign => {
        delete campaign.name
        delete campaign.nameLat
        campaign.requirements.purchasedProducts = campaign.requirements.purchasedProducts.map(product => {
          return {productId: product.productID ? product.productID : product.productId}
        })

        campaign.rewards.awardedProducts = campaign.rewards.awardedProducts.map(product => {
          return {productId: product.productID ? product.productID : product.productId}
        })



        if (typeof campaign.rewards.redemptionLimit !== 'undefined')
        {
          console.log('campaign.rewards.redemptionLimit', campaign.rewards.redemptionLimit)

          if (campaign.rewards.redemptionLimit === '')
            campaign.rewards.redemptionLimit = null;
        }

        if (typeof campaign.rewards.salesRedemptionLimit !== 'undefined')
        {
          console.log('campaign.rewards.salesRedemptionLimit', campaign.rewards.salesRedemptionLimit)

          if (campaign.rewards.salesRedemptionLimit === '')
            campaign.rewards.salesRedemptionLimit = null;
        }

        if (typeof campaign.oncePerDay == 'undefined' || campaign.oncePerDay === '')
        {
          campaign.oncePerDay = 0;
        } else {
          campaign.oncePerDay = parseInt(campaign.oncePerDay)
        }


        if (campaign.type === 'MULTIBUY_X_FOR_DISCOUNT' || campaign.type === 'MULTIBUY_GET_PERCENTAGE_OFF' || campaign.type === 'MULTIBUY_GET_SUM_OFF') {
          console.log('before 3')
          console.log(campaign)
          campaign.rewards.sumOffMatchingItems = campaign.rewards.sumOff ? campaign.rewards.sumOff.valueOf() : campaign.rewards.sumOffMatchingItems
          campaign.rewards.percentageOffMatchingItems = campaign.rewards.percentageOff ? campaign.rewards.percentageOff.valueOf() : campaign.rewards.percentageOffMatchingItems

          console.log('before 31')
          console.log(campaign)
          console.log('delete 3')
          delete campaign.rewards.sumOff
          delete campaign.rewards.percentageOff
        }

        //same for edit.
        if (campaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || campaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {
          if (!campaign.rewards.percentageOff) {
            delete campaign.rewards.percentageOff
          }

          if (!campaign.rewards.percentageOffMatchingItems ) {
            delete campaign.rewards.percentageOffMatchingItems
          }

          if (!campaign.rewards.sumOffMatchingItems) {
            delete campaign.rewards.sumOffMatchingItems
          }
        }

        if (campaign.type == 'SPEND_GET_SUM_OFF_ITEMS' || campaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS' || campaign.type == 'MULTIBUY_GET_SUM_OFF' || campaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS') {

          delete campaign.rewards.specialUnitPrice
        }

        if (campaign.type == 'BUY_ITEMS_FOR_SPECIAL_UNIT_PRICE' || campaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

          if (!campaign.rewards.percentageOffMatchingItems ) {
            delete campaign.rewards.percentageOffMatchingItems
          }

          if (!campaign.rewards.sumOffMatchingItems) {
            delete campaign.rewards.sumOffMatchingItems
          }
          delete campaign.subsidyPercentageOfDiscount
          delete campaign.rewards.rewardMoneyEarnedPerRedemption
        }

        if (campaign.type == 'SPEND_GET_PERCENTAGE_OFF_ITEMS') {

          if (!campaign.rewards.sumOff ) {
            delete campaign.rewards.sumOff
          }

        }

        if (campaign.type == 'MULTIBUY_GET_SUM_OFF') {
          if (!campaign.rewards.percentageOffMatchingItems ) {
            delete campaign.rewards.percentageOffMatchingItems
          }
          delete campaign.subsidyPercentageOfDiscount
          delete campaign.rewards.rewardMoneyEarnedPerItem
        }

        if (campaign.type == 'MULTIBUY_GET_PERCENTAGE_OFF') {
          delete campaign.subsidyPercentageOfDiscount
          delete campaign.rewards.rewardMoneyEarnedPerItem
        }


        if (campaign.type == 'BUY_ITEMS_GET_SUM_OFF_ITEMS' || campaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {

          campaign.rewards.salesRedemptionLimit = campaign.rewards.redemptionLimit

          delete campaign.rewards.redemptionLimit
        }

        if (campaign.type == 'BUY_ITEMS_GET_PERCENTAGE_OFF_ITEMS') {
          delete  campaign.rewards.rewardMoneyEarnedPerItem
          delete campaign.targetMargin
        }
        //////////////////////////////////////////////////////////////////

        if (campaign.hasBeenEdited) {
          campaignPromises.push(this.api.campaigns.edit(event.id, campaign))
        }
      })
      return { campaignPromises, campaignErrors }

  }

  lockEvent (event) {
    event.locked = true
    return this.api.events.save(event)
  }

  unlockEvent (event) {
    event.locked = false
    return this.api.events.save(event)
  }

  confirmEvent (event) {
    event.active = true
    return this.api.events.save(event)
  }

  unconfirmEvent (event) {
    event.active = false
    return this.api.events.save(event)
  }

  deleteEvent (id) {
    return this.api.events.deleteEvent(id)
      .then(response => {
        return response
      })
      .catch(error => {
        return error
      })
  }

  getEventCodeOccurrences (excludeEventId) {
    return this.api.events.getEvents()
      .then(events => {
        return events.map(event => {
          if (event.id !== parseInt(excludeEventId)) {
            return {
              eventCode: event.eventCode.toLowerCase(),
              regionId: parseInt(event.regionId),
              type: event.type
            }
          }
        })
      })
  }

}

export default EventRepository




// WEBPACK FOOTER //
// ./src/model/EventRepository.js